<template>
  <VModal
    v-if="opened"
    version="new"
    title="Drip URL"
    :actions="actions"
    classType="primary"
  >
    <div class="description">
      Copy the below link into a Drip workflow to set up direct mail with Inkit. <br />

      <VLink
        type="primary"
        href="https://help.inkit.com/hc/en-us/articles/360036546913-Drip-Inkit-Integration"
        label="Need more info?"
        extraClass="send-hubspot__info-link"
        blank
      >
      </VLink>
    </div>

    <div class="v-pre-wrapper">
      <VPre label="Link" :text="dripLink" classType="primary" withCopy></VPre>
    </div>
  </VModal>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";
import VPre from "@/components/VPre";
import VModal from "@/components/VModal";

export default Vue.component("TemplatesSendDripModal", {
  props: {
    dripLink: VueTypes.string.isRequired,
    opened: VueTypes.bool.def(false)
  },

  components: {
    VPre,
    VModal
  },

  data() {
    return {
      actions: [
        {
          label: "OK",
          value: "cancel",
          type: "primary",
          size: "regular",
          click: () => this.$emit("close")
        }
      ]
    };
  }
});
</script>

<style lang="scss" scoped>
.description {
  margin-bottom: 50px;
  font-size: 22px;
  line-height: 1.5;
  color: $main-text-color;
  font-family: Lato-Light, Arial, Helvetica Neue, Helvetica, sans-serif;
}

.v-pre-wrapper {
  margin-bottom: 250px;
}
</style>
